import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2, ShieldCheck, Zap, FileText } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-brand-darker text-white overflow-hidden pt-20 pb-24 px-6 lg:px-8" data-id="element-68">
      {/* Abstract Background Elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] opacity-10 pointer-events-none" data-id="element-69">
        <div className="absolute inset-0 bg-gradient-to-b from-brand-accent/20 to-transparent rounded-full blur-3xl" data-id="element-70"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-71">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-72">
          {/* Left Column: Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left order-2 lg:order-1" data-id="element-73">
            <span className="inline-block py-1.5 px-4 rounded-full bg-brand-secondary/10 text-brand-secondary text-xs font-bold tracking-wider uppercase mb-6 border border-brand-secondary/20" data-id="element-74">
              Guía digital descargable
            </span>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-75">
              Lanza tu micro-emprendimiento digital en{' '}
              <span className="text-brand-accent" data-id="element-76">7 días</span>
            </h1>

            <p className="text-lg md:text-xl text-slate-300 font-medium mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-77">
              Convierte tus habilidades en ingresos reales con una guía
              práctica, clara y diseñada para empezar desde cero.
            </p>

            <ul className="space-y-3 mb-10 text-left max-w-md mx-auto lg:mx-0" data-id="element-78">
              {['Sin experiencia previa', 'Sin gran inversión', 'Paso a paso simple y accionable'].map((bullet, i) => <li key={i} className="flex items-center gap-3 text-slate-200" data-id="element-79">
                  <CheckCircle2 className="w-5 h-5 text-brand-accent shrink-0" data-id="element-80" />
                  <span className="font-medium" data-id="element-81">{bullet}</span>
                </li>)}
            </ul>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-82">
              <div className="flex items-center gap-3 mb-2" data-id="element-83">
                <span className="text-slate-500 line-through text-lg font-bold" data-id="element-84">
                  $27 USD
                </span>
                <span className="text-3xl font-heading font-extrabold text-white" data-id="element-85">
                  $7.39 USD
                </span>
              </div>

              <button onClick={() => document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            })} className="w-full sm:w-auto px-10 py-5 bg-brand-accent hover:bg-brand-accentHover text-white font-bold rounded-xl text-xl transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_30px_rgba(34,197,94,0.4)] flex items-center justify-center gap-3 group" data-id="element-86">
                Descargar ahora
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-87" />
              </button>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs text-slate-400 mt-2 font-medium" data-id="element-88">
                <span className="flex items-center gap-1" data-id="element-89">
                  <Zap className="w-3.5 h-3.5" data-id="element-90" /> Acceso inmediato
                </span>
                <span className="hidden sm:inline" data-id="element-91">•</span>
                <span className="flex items-center gap-1" data-id="element-92">
                  <ShieldCheck className="w-3.5 h-3.5" data-id="element-93" /> Pago 100% seguro
                </span>
                <span className="hidden sm:inline" data-id="element-94">•</span>
                <span className="flex items-center gap-1" data-id="element-95">
                  <FileText className="w-3.5 h-3.5" data-id="element-96" /> Formato PDF
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Product Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-97">
            <div className="relative" data-id="element-98">
              <div className="absolute inset-0 bg-brand-accent/20 blur-3xl rounded-full" data-id="element-99"></div>
              <img src="https://cdn.magicpatterns.com/uploads/nok7wXRxCZ1wQoMoRCHHB1/portada_4.png" alt="Guía de Micro-Emprendimiento - Vista previa en móvil" className="relative z-10 w-64 md:w-80 lg:w-[400px] drop-shadow-[0_20px_40px_rgba(34,197,94,0.15)]" data-id="element-100" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}